import { ISSUER_RATESDETAILS } from '../actionTypes';

export const fetchIssuerRatesDetails = (action) => ({
  type: ISSUER_RATESDETAILS.FETCH,
  payload: action.payload,
});
